import { QuestionnaireAnswerType } from 'components/Assessments/types'
import { VitalsQuestionnaireItem } from './questionnaire'

export const VITALS_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE = {
  [VitalsQuestionnaireItem.VITALS_TEMPERATURE]: QuestionnaireAnswerType.STRING,
  [VitalsQuestionnaireItem.VITALS_PULSE]: QuestionnaireAnswerType.STRING,
  [VitalsQuestionnaireItem.VITALS_RESPIRATIONS]: QuestionnaireAnswerType.STRING,
  [VitalsQuestionnaireItem.VITALS_O2_SATURATION]: QuestionnaireAnswerType.STRING,
  [VitalsQuestionnaireItem.VITALS_BLOOD_PRESSURE]: QuestionnaireAnswerType.STRING,
  [VitalsQuestionnaireItem.VITALS_HEIGHT]: QuestionnaireAnswerType.STRING,
  [VitalsQuestionnaireItem.VITALS_BLOOD_SUGAR]: QuestionnaireAnswerType.STRING,
  [VitalsQuestionnaireItem.VITALS_WEIGHT]: QuestionnaireAnswerType.STRING,
  [VitalsQuestionnaireItem.VITALS_INITIALS_AUTHORIZATION]: QuestionnaireAnswerType.STRING
}
